import { IntakeLabelCollection } from '../../entities/intake-label.interface';
export const AishOboLabels: IntakeLabelCollection = {
  applyingFor: {
    label: 'Who is this application for?',
  },
  applyingForSection: {
    label: 'Who are you applying for?',
  },
  firstName: {
    label: 'First name',
  },
  lastName: {
    label: 'Last name',
  },
  birthdate: {
    label: 'Birthdate',
  },
  birthdateNote: {
    label: "Note: You cannot submit an application until at least 6 months before the applicant's 18th birthday.",
  },
};
